export default "__VITE_ASSET__B$jy6sMi__"